import { Link } from 'react-router-dom';
import { siteConfig } from '@/config/site';

function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-heading text-7xl font-bold text-primary-500">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950">页面不存在</h1>
      <p className="mt-2 text-sm text-foreground-600">您访问的页面可能已被移动或删除。</p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line mr-2"></i>
        返回{siteConfig.name}首页
      </Link>
    </div>
  );
}

export default NotFound;